import {pinyin} from "pinyin-pro";
import axios from "axios";
import moment from "moment";

export default class CommonHelp {
  static getMonths(startDate,endDate) {
    var d1 = startDate;
    var d2 = endDate;
    var dateArry = new Array();
    var s1 = d1.split("-");
    var s2 = d2.split("-");
    var mCount = 0;
    if (parseInt(s1[0]) < parseInt(s2[0])) {
      mCount = (parseInt(s2[0]) - parseInt(s1[0])) * 12 + parseInt(s2[1]) - parseInt(s1[1])+1;
    } else {
      mCount = parseInt(s2[1]) - parseInt(s1[1])+1;
    }
    if (mCount > 0) {
      var startM = parseInt(s1[1]);
      var startY = parseInt(s1[0]);
      for (var i = 0; i < mCount; i++) {
        if (startM < 12) {
          dateArry[i] = startY + "-" + (startM>9 ? startM : "0" + startM);
          startM += 1;
        } else {
          dateArry[i] = startY + "-" + (startM > 9 ? startM : "0" + startM);
          startM = 1;
          startY += 1;
        }
      }
    }
    return dateArry;
  }
  static getPinyinFast(str){
    return pinyin(str,{
      pattern:"first",
      toneType: 'none',
      type: 'array'
    }).join("").toUpperCase();
  }
  static get(url, data, callback){
    ERP.getRequest({url:url, data:data}, callback)
  }
  static post(url, data, callback){
    ERP.postRequest({url:url, data:data}, callback)
  }
  static uploadFile(callback){
    let upload=document.getElementById("uploadFile-9999");
    if(!upload){
      upload=document.createElement('input');
      upload.type="file";
      upload.id="uploadFile-9999";
      upload.style.display="none";
    }
    upload.click();
    upload.onchange=function (e) {
      let formData = new FormData();
      formData.append("file",this.files[0]);
      axios.post(CommonHelp.getBaseURL()+'/contract/contract/uploadFile',formData).then(res=>{
        if(res){
          typeof callback==="function"&&callback(res.data.data.path)
        }
      },err=>{

      })

      upload.onchange=undefined;

    }

  }
  static getBaseURL(){
    return axios.defaults.baseURL
  }
  static date(format="YYYY-MM-DD",time=null){
    if(!time){
      time=new Date();
    }
    return moment(time).format(format)
  }
}



// WEBPACK FOOTER //
// ./src/components/Admin/Cms/common/CommonHelp.js